import { Box } from '@mui/material';
import { mergeSx } from 'merge-sx';
import { memo, useState } from 'react';
import * as Styled from './styles';
import type { ImageWithFallbackProps as Props } from './types';

export const ImageWithFallback = memo(
  ({ src, width, height, alt, fallback, sx, fallbackSx }: Props) => {
    const [imgError, setImgError] = useState(false);

    return imgError ? (
      <Box
        style={{
          width,
          height,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
        sx={mergeSx(sx, fallbackSx)}
      >
        {fallback || alt}
      </Box>
    ) : (
      <Styled.Image
        src={src}
        alt={alt}
        width={width}
        height={height}
        onError={() => setImgError(true)}
        sx={sx}
      />
    );
  }
);

ImageWithFallback.displayName = 'ImageWithFallback';
